import { userInfoStore } from "Stores";
import { UserActiveTokens } from "./UserActiveTokens";
import { observer } from "mobx-react";
import { Divider } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

export const UserAuthentications = observer(() => {
  const { t } = useTranslation(I18N_NS.USER_SETTINGS);
  return (
    <div>
      <Divider>{t("Active Authentications")}</Divider>
      <UserActiveTokens userId={userInfoStore.id} unifiedAccount={userInfoStore.loginInfo.unifiedAccount} />
    </div>
  );
});
